import queryString from 'query-string';

import { ApiResps } from '~/providers';

export type VrfDevice = Pick<ApiResps['/get-integrations-list']['list'][number], 'dataSource' | 'integrId'>;

/**
 * Ordena os DVIs pelo nome exibido no seletor. A comparação numérica evita que
 * "DVI 10" apareça antes de "DVI 2", e a sensibilidade "base" ignora caixa e acentos.
 */
export function sortDevicesByDataSource<T extends Pick<VrfDevice, 'dataSource'>>(devices: readonly T[]): T[] {
  return [...devices].sort((a, b) => (a.dataSource ?? '').localeCompare(b.dataSource ?? '', 'pt-BR', { numeric: true, sensitivity: 'base' }));
}

/** Parâmetro de query que indica qual DVI deve abrir selecionado na tela Sistemas VRF da unidade. */
export const VRF_DEVICE_QUERY_PARAM = 'dvi';

/** Link para a tela Sistemas VRF da unidade, abrindo no Tempo Real com o DVI indicado selecionado. */
export function buildUnitVrfLink(unitId: number, integrId: string): string {
  return `/analise/unidades/integracao-vrf/${unitId}?${queryString.stringify({ aba: 'tempo-real', [VRF_DEVICE_QUERY_PARAM]: integrId })}`;
}

/**
 * Escolhe o DVI que abre selecionado: o indicado na URL, se pertencer à unidade;
 * caso contrário, o primeiro da lista já ordenada.
 */
export function pickInitialDevice<T extends Pick<VrfDevice, 'integrId'>>(sortedDevices: readonly T[], preferredIntegrId: string | null): T | null {
  const preferredDevice = preferredIntegrId ? sortedDevices.find((device) => device.integrId === preferredIntegrId) : undefined;
  return preferredDevice ?? sortedDevices[0] ?? null;
}
